export const ErrorPage: React.FC = () => {
    return <div>This is a problem bro</div>;
};
